export const localeToBackendMap: Record<string, string> = {
  en: "en_US",
  "en-GB": "en_GB",
  fr: "fr_FR",
  de: "de_DE",
  zh: "zh_HANS",
  "zh-Hant": "zh_HANT",
  "es-419": "es_419",
  "es-ES": "es_ES",
  it: "it_IT",
  pt: "pt_BR",
  ko: "ko_KR",
};

export const backendToLocaleMap: Record<string, string> = Object.assign(
  {},
  ...Object.entries(localeToBackendMap).map(([a, b]) => ({ [b]: a })),
);
